import instance from "../../../../../../services/api";

export const getDebtsDetail = async debt_id => {
  if (!debt_id) return;
  return await instance(true)
    .get(`/partner/debts/debt/${debt_id}/history/`)
    .then(res => res?.data);
};
